import styled from 'styled-components'
import PuffLoader from 'react-spinners/PuffLoader'

const LoaderWrapper = styled.div<{ $isFixed?: boolean }>`
  position: ${({ $isFixed = false }) => ($isFixed ? 'fixed' : 'absolute')};
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 1em;
`

export const PrimaryLoader = styled(PuffLoader).attrs(({ theme }) => ({
  color: theme.colors.ngprimary950,
}))``

export type FullPageLoaderProps = {
  'data-testid'?: string
  $isFixed?: boolean
  loadingText?: string
}

export default function FullPageLoader(props: FullPageLoaderProps) {
  return (
    <LoaderWrapper {...props}>
      <PrimaryLoader />
      {props.loadingText && <div>{props.loadingText}</div>}
    </LoaderWrapper>
  )
}
